class ContactDetails extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.render();
    }
    
    static get observedAttributes() {
        return ['phone-label','phone','shipping'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.log(name, oldValue, newValue);

        if(name === 'phone-label'){
            this.phoneLabel = newValue;
        }
    
        if(name === 'phone'){
            this.phone = newValue;
        }
        if(name === 'shipping'){
            this.shipping = newValue;
        }
        this.render();
    }


    render() {
      this.shadowRoot.innerHTML = `
        <style>
        .contact-details-container{
          display:none;
        }
          @media screen and (min-width: 811px){
            .contact-details-container{
                display: flex;
                flex-direction: column;
                text-align: right;
            }
          }
            
            
        </style>
        <div class="contact-details-container">
          <span>${this.getAttribute('phone-label')}: <strong>${this.getAttribute('phone')}</strong></span>
          <span>${this.getAttribute('shipping')}</span>
            <div class="links">
            <a href="/blogs/the-beautiful-hair-blog/">
              <img class="small-ico" border="0" alt="Blog" src="https://cdn.shopify.com/s/files/1/1025/3631/files/J24-NBW_Blog.png?8445047429549606153" height="40">
            </a>
            <a href="/pages/beginner-basics/"> 
                <img border="0" alt="Beginner Basics" src="https://cdn.shopify.com/s/files/1/1025/3631/files/New_to_Wigs_-_Dusty_Rose.png?v=1631825563" height="51" style="margin: 0px 0px -5px 0px;">
            </a>
            </div>
        </div>`;
    }
  }
  
  // Define the new element
  console.log("Define the ContactDetails element")
  customElements.define('contact-details', ContactDetails);
  console.log("Element ContactDetails Defined")
  
  setTimeout(async () => {
  
  },500)
  